module.exports = __webpack_public_path__ + "img/ELW_2.f1e36c59.svg";